import { firestoreAction } from 'vuexfire'
import { docRef } from '../../../_services/firebase/db.js'
import { collectionRef } from '../../../_services/firebase/db.js'
import firebase from 'firebase/compat/app'
//import classroom from '../../../models/Classroom'
//import codeAssignment from '../../../models/User.js'
//import { Notify } from 'quasar'
import 'firebase/firestore'

export const addCodeAssignmentToCACollection = function (state) {
  console.log(state)
  //var newDoc = ''

  return collectionRef('codeAssigments')
    .add({
      registrationCode: state.code,
      creatorid: state.currentUserId,
      classroom: state.classroomId,
      dateCreated: firebase.firestore.Timestamp.now()
    })
    .then(function (assignment) {
      console.log(assignment)
      return assignment.id
    })
    .catch(function (error) {
      console.error('Error adding document: ', error)
    })
}

export const addClassroomToCRCollection = async function (state) {
  //const classroomname =state.classroomName;
  //const classroom = new classroom({code});
  //classroom.creatorid=state.currentUserId;
  //classroom.classroomname="";
  //clasroom.grade= state.classGrade;
  console.log(state)
  //var newDoc = ''

  return collectionRef('classrooms')
    .add({
      creatorid: state.currentUserId,
      classroomname: state.classroomName,
      dateCreated: firebase.firestore.Timestamp.now(),
      archived: false
    })
    .then(function (docRef) {
      console.log(docRef)
      return docRef.id
    })
    .catch(function (error) {
      console.error('Error adding document: ', error)
    })
}
/** Get current user from the firestore collection user's
 * via firebase uid
 * @param  {String} id - Firebase currentUser id
 * @returns {Function} bindFirestoreRef - https://vuefire.vuejs.org/api/vuexfire.html#bindfirestoreref
 */
export const getCurrentUser = firestoreAction(({ bindFirestoreRef }, id) => {
  return bindFirestoreRef('codeAssignment', docRef('codeAssignments', id))
})
/**
 * @param {Object} $root - Place holder argument(Vuex store) to allow data to be passed
 *  as second argument.
 * @param data.email - User's email
 * @param data.password - User's password
 * @returns {function} - Firebase services function:
 * src/services/firebase/email.js > createUserWithEmail
 */
export const createNewCodeAssignment = async function ($root, data) {
  //  const $fb = this.$fb
  // console.log(data)
  //const { email, password } = data
  //console.log(email)
  //console.log(password)
  //const fbAuthResponse = await $fb.createUserWithEmail(email, password)
  console.log(data)
  //const id = fbAuthResponse.user.uid
  // const userRef = docRef('users', id)
  //const result= await addClassroomToCRCollection(data);

  return addCodeAssignmentToCACollection(data)
}
export const checkCodeExistence = async function ($root, data) {
  console.log(data)
  var exists = await collectionRef('codeAssigments') //FIX TYPO
    .where('registrationCode', '==', data)
    .get()
    .then((querySnapshot) => {
      console.log(querySnapshot)
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        console.log(doc.id, ' => ', doc.data())
      })
      return querySnapshot.size
    })
    .catch((error) => {
      console.log('Error getting documents: ', error)
    })
  console.log(exists)

  return exists > 0
}

export const createNewClassroom = async function ($root, data) {
  //const $fb = this.$fb
  console.log(this.commit)

  const result = await addClassroomToCRCollection(data)
  console.log(result)
  this.commit('classroom/setCurrentClassroom', result)
  return result
}

/**
 * @param {Object} $root - Place holder argument(Vuex store) to allow data to be passed
 *  as second argument.
 * @param data.id - Firestore document id
 * @param {Object} data - User's data to be updated
 * @returns {Function} - Firebase services function:
 * src/services/firebase/db.js > docRef
 */
export const updateUserData = async function ($root, data) {
  return docRef('users', data.id).update(data)
}
